import { Currencies } from '@payu/paymentsos-types'
import { createSelector } from 'reselect'

import { State } from './reducer'

interface Store {
  Countries: State
}

export const getCountries = (state: Store): Currencies.Currency[] => state.Countries.countries

interface MapType {
  [x: string]: string
}

export const getCountryCodeToCountryNameMap = createSelector(getCountries,
  (countries): MapType => countries.reduce(
    (acc, country) => { acc[country.code] = country.name; return acc }, {}
  ))

export const getCountryNameToCountryCodeMap = createSelector(getCountries,
  (countries): MapType => countries.reduce(
    (acc, country) => { acc[country.name] = country.code; return acc }, {}
  ))
